var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThreadsLogoDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 900.52 429.74",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3,.cls-4,.cls-5{stroke-width:0px;}.cls-3{fill:#fc3165;}.cls-6{clip-path:url(#clippath-1);}.cls-4{fill:#ffffff;}.cls-5{fill:#fa3165;}\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 589.24,
    y: 141.8,
    width: 146.17,
    height: 146.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 161.99,
    y: 141.8,
    width: 141.88,
    height: 146.14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2306"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    className: "cls-4",
    d: "M700.58,252.71c-12.49.85-25.72-8.47-29.85-21.14-1.03-3.68-1.63-7.46-1.78-11.28-.29-3.72-.06-7.48-.06-11.55-1.14-.05-2.11-.1-3.09-.14-5.43-.23-10.96.14-16.27-.79-13.97-2.45-24.58-15.07-25.25-29.23.01-.59.06-1.18.14-1.76h67.93c6.24,0,8.23,2.01,8.23,8.28,0,21.57,0,43.14,0,64.71v2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    className: "cls-4",
    d: "M703.73,173.53c-4.57,0-8.73.02-12.89,0-17.09-.02-31.11-13.53-31.76-30.61.02-.38.07-.75.14-1.12h68.77c5.11,0,7.4,2.21,7.41,7.24.02,22.08.02,44.15,0,66.23,0,.75-.09,1.49-.14,2.42-7.53.16-14.84-2.54-20.46-7.56-7-5.8-11.05-14.42-11.05-23.52-.07-4.24-.01-8.49-.01-13.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    className: "cls-4",
    d: "M665.56,287.94c-17.58-.16-31.7-14.55-31.54-32.13,0-.03,0-.07,0-.1-.02-3.9,0-7.81,0-12.02-4.35,0-8.5.01-12.64,0-14.96.12-27.95-10.26-31.15-24.87-.49-2.13-.63-4.34-.99-6.86h69.18c4.93,0,7.27,2.11,7.27,6.8.04,22.59.04,45.18,0,67.77,0,.34-.07.67-.14,1.41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2307"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    className: "cls-3",
    d: "M299.89,200.2c5.43,5.6,5.29,14.54-.31,19.97-.04.04-.08.08-.12.12-5.55,5.54-14.55,5.53-20.09-.02-5.54-5.55-5.53-14.55.02-20.09.09-.09.18-.18.27-.26,5.55-5.51,14.52-5.47,20.03.08.07.07.13.14.2.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    className: "cls-3",
    d: "M261.44,237.36c.29-26.69.14-53.23,0-79.92,0-9.18-6.03-15.64-14.35-15.64s-14.2,6.45-14.2,15.64c0,11.48,0,23.1.14,35.15-2.01-.72-3.44-1.29-4.74-1.72-23.91-8.37-50.29,2.57-61.27,25.39-11.14,22.61-3.4,49.98,17.93,63.42,16.5,10.33,33.71,11.05,50.65,1.72s25.54-24.53,25.82-44.04M196.16,252.56c-7.75-8.46-7.46-22.38.72-29.99,8.64-8.02,22.11-7.63,30.27.86,7.9,8.54,7.45,21.85-1.01,29.84-8.61,7.89-22.24,7.6-29.99-.72"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 0,
    width: 900.4,
    height: 429.74
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    className: "cls-4",
    d: "M667.6,343.5c-1.46-.11-2.94-.2-4.38-.34,1.43.14,2.91.23,4.38.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    className: "cls-4",
    d: "M659.03,342.68c-1.17-.14-2.36-.25-3.51-.4,1.15.15,2.34.27,3.51.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    className: "cls-4",
    d: "M643.4,340.2c-.86-.17-1.73-.32-2.58-.51.84.18,1.72.33,2.58.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    className: "cls-4",
    d: "M843.78,362.45c-1.48,1.59-2.99,3.16-4.52,4.71,1.53-1.55,3.04-3.12,4.52-4.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    className: "cls-4",
    d: "M650.9,341.56c-.94-.15-1.91-.28-2.84-.44.93.16,1.9.29,2.84.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    className: "cls-4",
    d: "M837.9,368.53c.07-.07.14-.15.22-.22-.43.43-.87.85-1.3,1.27.36-.35.73-.7,1.09-1.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    className: "cls-4",
    d: "M765.65,318.85c-.23.17-.45.34-.67.51.23-.17.45-.34.67-.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    className: "cls-4",
    d: "M770.79,314.79c-.35.29-.69.59-1.04.88.35-.29.69-.59,1.04-.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    className: "cls-4",
    d: "M636.33,338.61c-.83-.21-1.68-.38-2.5-.6.82.22,1.67.4,2.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    className: "cls-4",
    d: "M775.72,310.41c-.47.44-.94.9-1.42,1.33.48-.43.94-.89,1.42-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    className: "cls-4",
    d: "M834.34,371.97c-.44.41-.88.82-1.33,1.23.44-.41.89-.82,1.33-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    className: "cls-4",
    d: "M760.34,322.6c-.11.07-.21.15-.32.22.11-.07.21-.15.32-.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    className: "cls-4",
    d: "M679.44,344.12c-2.79-.07-5.54-.18-8.24-.34,2.7.16,5.45.27,8.24.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    className: "cls-4",
    d: "M592.23,320.32c-.58-.36-1.18-.69-1.75-1.05.58.36,1.17.7,1.75,1.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    className: "cls-4",
    d: "M629.36,336.73c-.77-.23-1.55-.43-2.3-.66.76.23,1.54.43,2.3.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    className: "cls-4",
    d: "M864.96,335.51c-1.26,1.9-2.55,3.79-3.87,5.65,1.32-1.86,2.61-3.75,3.87-5.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    className: "cls-4",
    d: "M779.06,307.2c.46-.47.9-.97,1.35-1.45-.58.61-1.16,1.23-1.75,1.83.13-.13.27-.25.4-.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    className: "cls-4",
    d: "M869.65,328.09c-1.12,1.87-2.28,3.72-3.47,5.55,1.18-1.83,2.34-3.68,3.47-5.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    className: "cls-4",
    d: "M597.98,323.67c-.61-.34-1.24-.66-1.85-1.01.61.35,1.23.67,1.85,1.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    className: "cls-4",
    d: "M575.95,308.94c-.53-.42-1.07-.82-1.59-1.24.53.43,1.06.82,1.59,1.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    className: "cls-4",
    d: "M581.23,312.95c-.54-.4-1.1-.77-1.63-1.18.54.4,1.09.78,1.63,1.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    className: "cls-4",
    d: "M586.66,316.76c-.56-.38-1.14-.74-1.7-1.12.56.38,1.14.74,1.7,1.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    className: "cls-4",
    d: "M622.71,334.62c-.74-.25-1.49-.48-2.22-.74.73.26,1.48.49,2.22.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    className: "cls-4",
    d: "M616.2,332.24c-.69-.27-1.39-.52-2.07-.8.68.28,1.39.52,2.07.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    className: "cls-4",
    d: "M849.56,355.97c-1.54,1.81-3.12,3.59-4.72,5.35,1.61-1.76,3.18-3.54,4.72-5.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    className: "cls-4",
    d: "M859.92,342.8c-1.19,1.65-2.41,3.28-3.65,4.89,1.24-1.61,2.46-3.25,3.65-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    className: "cls-4",
    d: "M603.86,326.76c-.63-.31-1.27-.61-1.9-.93.62.32,1.27.62,1.9.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    className: "cls-4",
    d: "M609.92,329.62c-.66-.29-1.33-.56-1.98-.86.65.3,1.32.57,1.98.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    className: "cls-4",
    d: "M855.35,348.9c-1.45,1.86-2.95,3.69-4.47,5.51,1.52-1.82,3.02-3.65,4.47-5.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    className: "cls-4",
    d: "M788.91,295.77c-.73.96-1.45,1.91-2.2,2.84.75-.93,1.47-1.89,2.2-2.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    className: "cls-4",
    d: "M787.63,405.23l-.2.1.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    className: "cls-4",
    d: "M792.22,402.76l-.36.19.36-.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    className: "cls-4",
    d: "M796.75,400.18c-.17.1-.35.2-.52.3.17-.1.35-.2.52-.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    className: "cls-4",
    d: "M782.98,407.58s-.05.02-.08.04c.03-.01.05-.03.08-.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    className: "cls-4",
    d: "M717.91,427.47c-.27.04-.54.07-.8.1.27-.04.54-.07.8-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    className: "cls-4",
    d: "M723.17,426.66c-.12.02-.24.04-.35.05.12-.02.23-.04.35-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    className: "cls-4",
    d: "M728.4,425.72l-.12.02.12-.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    className: "cls-4",
    d: "M805.62,394.68c-.27.18-.54.35-.81.52.27-.17.54-.34.81-.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    className: "cls-4",
    d: "M818.4,385.59c-.38.3-.77.58-1.16.87.39-.29.77-.58,1.16-.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    className: "cls-4",
    d: "M822.5,382.34c-.41.33-.82.65-1.24.98.41-.33.83-.65,1.24-.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    className: "cls-4",
    d: "M814.21,388.73c-.35.25-.7.5-1.05.75.35-.25.7-.5,1.05-.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    className: "cls-4",
    d: "M809.95,391.76c-.31.22-.64.43-.95.65.32-.22.64-.43.95-.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    className: "cls-4",
    d: "M784.81,300.86c-.67.78-1.33,1.57-2.02,2.34.69-.77,1.35-1.56,2.02-2.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    className: "cls-4",
    d: "M801.22,397.49c-.22.14-.45.27-.67.4.22-.14.45-.27.67-.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    className: "cls-4",
    d: "M712.6,428.16c-.4.05-.81.08-1.22.13.4-.04.81-.08,1.22-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    className: "cls-4",
    d: "M802.25,273.63c-.73,1.56-1.47,3.1-2.26,4.62.79-1.52,1.53-3.06,2.26-4.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    className: "cls-4",
    d: "M804.84,267.7c-.68,1.68-1.39,3.36-2.14,5,.75-1.65,1.46-3.32,2.14-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    className: "cls-4",
    d: "M826.53,378.99c-.43.37-.86.72-1.29,1.08.43-.36.86-.71,1.29-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    className: "cls-4",
    d: "M570.79,304.7c-.51-.44-1.04-.85-1.55-1.3.51.45,1.03.86,1.55,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    className: "cls-4",
    d: "M796.18,285.03c-.77,1.27-1.54,2.54-2.35,3.78.81-1.24,1.58-2.51,2.35-3.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    className: "cls-4",
    d: "M707.26,428.73c-.54.05-1.09.09-1.63.13.55-.05,1.09-.08,1.63-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    className: "cls-4",
    d: "M792.7,290.49c-.75,1.12-1.51,2.23-2.3,3.32.79-1.09,1.55-2.2,2.3-3.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    className: "cls-4",
    d: "M807.13,261.63c-.63,1.8-1.29,3.59-1.99,5.36.7-1.76,1.36-3.55,1.99-5.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    className: "cls-4",
    d: "M685.54,429.74c1.83,0,3.66-.02,5.48-.06-1.82.04-3.65.06-5.48.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    className: "cls-4",
    d: "M696.47,429.48c-1.21.06-2.42.09-3.62.13,1.21-.04,2.42-.07,3.62-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    className: "cls-4",
    d: "M701.88,429.17c-.8.06-1.61.09-2.42.14.81-.05,1.62-.09,2.42-.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    className: "cls-4",
    d: "M810.83,249.08c-.49,2.02-1.02,4.03-1.6,6.01.58-1.98,1.11-3.99,1.6-6.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    className: "cls-4",
    d: "M809.13,255.43c-.56,1.91-1.17,3.81-1.81,5.68.64-1.87,1.25-3.77,1.81-5.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    className: "cls-4",
    d: "M830.48,375.53c-.44.39-.88.77-1.32,1.16.44-.39.88-.77,1.32-1.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    className: "cls-4",
    d: "M799.37,279.41c-.75,1.42-1.52,2.83-2.33,4.21.81-1.38,1.57-2.79,2.33-4.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    className: "cls-4",
    d: "M887.86,289.38c-.79,2.25-1.62,4.48-2.49,6.7.87-2.22,1.7-4.45,2.49-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    className: "cls-4",
    d: "M528.3,257.02c-.38-.52-.76-1.04-1.14-1.57.38.53.76,1.04,1.14,1.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    className: "cls-4",
    d: "M523.8,250.68c-.35-.5-.7-1-1.05-1.5.35.51.7,1,1.05,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    className: "cls-4",
    d: "M896.7,256c-.44,2.44-.93,4.86-1.45,7.27.52-2.41,1.01-4.83,1.45-7.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    className: "cls-4",
    d: "M884.63,297.92c-.86,2.15-1.75,4.3-2.68,6.42.93-2.12,1.82-4.26,2.68-6.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    className: "cls-4",
    d: "M532.75,263.08c-.38-.51-.76-1-1.14-1.51.38.51.76,1,1.14,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    className: "cls-4",
    d: "M519.35,244.19c-.33-.49-.67-.97-1-1.47.33.5.67.98,1,1.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    className: "cls-4",
    d: "M514.87,237.46c-.3-.46-.61-.91-.91-1.38.3.46.61.91.91,1.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    className: "cls-4",
    d: "M895.04,264.23c-.55,2.49-1.15,4.96-1.79,7.41.64-2.46,1.23-4.93,1.79-7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    className: "cls-4",
    d: "M505.63,223.06c-.15-.24-.3-.48-.46-.72.15.24.3.48.46.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    className: "cls-4",
    d: "M814.86,215.12c-.01.39-.02.78-.03,1.19-.08,10.99-1.41,21.94-3.96,32.63,2.65-11.06,3.99-22.38,3.99-33.75v-.25.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    className: "cls-4",
    d: "M890.51,281.33c-.68,2.19-1.39,4.36-2.13,6.51.74-2.16,1.45-4.33,2.13-6.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    className: "cls-4",
    d: "M892.86,273.16c-.65,2.44-1.34,4.87-2.07,7.28.73-2.41,1.42-4.84,2.07-7.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    className: "cls-4",
    d: "M537.3,269.03c-.4-.52-.81-1.02-1.22-1.54.4.52.81,1.02,1.22,1.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    className: "cls-4",
    d: "M510.21,230.29c-.21-.33-.42-.66-.64-.99.21.33.43.66.64.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    className: "cls-4",
    d: "M898.22,246.53c1.35-9.76,2.08-19.6,2.16-29.46v-.39h-.09l-2.07,29.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    className: "cls-4",
    d: "M556.02,290.74c-.49-.51-.98-1-1.47-1.51.49.52.98,1.01,1.47,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    className: "cls-4",
    d: "M877.77,313.25c-1.01,2.04-2.06,4.06-3.14,6.07,1.08-2,2.12-4.03,3.14-6.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    className: "cls-4",
    d: "M873.58,321.24c-.98,1.78-1.99,3.55-3.02,5.3,1.03-1.75,2.04-3.52,3.02-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    className: "cls-4",
    d: "M900.39,216.41c0-.32.01-.64.01-.96v-.32l-.03.47c0,.27.02.55.02.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    className: "cls-4",
    d: "M565.74,300.24c-.5-.45-1-.89-1.49-1.35.49.46,1,.9,1.49,1.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    className: "cls-4",
    d: "M551.23,285.61c-.46-.51-.94-1.01-1.4-1.53.46.52.93,1.01,1.4,1.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    className: "cls-4",
    d: "M560.83,295.59c-.49-.48-.99-.94-1.48-1.43.49.49.99.95,1.48,1.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    className: "cls-4",
    d: "M546.53,280.29c-.45-.52-.9-1.02-1.34-1.54.45.52.9,1.02,1.34,1.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    className: "cls-4",
    d: "M541.9,274.78c-.43-.52-.86-1.04-1.3-1.57.43.53.86,1.04,1.3,1.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    className: "cls-4",
    d: "M881.39,305.58c-.87,1.93-1.76,3.85-2.69,5.76.92-1.9,1.82-3.82,2.69-5.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    className: "cls-4",
    d: "M898.09,247.47c-.37,2.57-.78,5.13-1.23,7.67.45-2.54.86-5.1,1.23-7.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    className: "cls-5",
    d: "M881.86,125.21c.66,1.5,1.3,3.01,1.93,4.52-.63-1.52-1.27-3.02-1.93-4.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    className: "cls-5",
    d: "M883.9,130.02c.62,1.5,1.22,3,1.8,4.52-.58-1.51-1.18-3.02-1.8-4.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    className: "cls-5",
    d: "M755.07,103.83c1.66.98,3.29,2,4.89,3.06-1.6-1.06-3.23-2.08-4.89-3.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    className: "cls-5",
    d: "M885.84,134.88c.57,1.49,1.12,2.99,1.66,4.49-.54-1.5-1.09-3-1.66-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    className: "cls-5",
    d: "M889.36,144.78c.48,1.46.94,2.93,1.39,4.4-.45-1.47-.91-2.94-1.39-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    className: "cls-5",
    d: "M890.94,149.81c.43,1.44.85,2.88,1.25,4.33-.4-1.45-.82-2.89-1.25-4.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    className: "cls-5",
    d: "M887.65,139.8c.52,1.48,1.03,2.96,1.52,4.45-.49-1.49-1-2.98-1.52-4.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    className: "cls-5",
    d: "M869.97,102.19c.82,1.38,1.63,2.77,2.43,4.17-.8-1.4-1.6-2.79-2.43-4.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    className: "cls-5",
    d: "M879.7,120.47c.7,1.49,1.38,2.99,2.05,4.5-.67-1.51-1.35-3.01-2.05-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    className: "cls-5",
    d: "M872.57,106.66c.8,1.42,1.58,2.85,2.35,4.29-.77-1.44-1.55-2.87-2.35-4.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    className: "cls-5",
    d: "M867.27,97.79c.84,1.33,1.67,2.68,2.48,4.03-.81-1.35-1.64-2.69-2.48-4.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    className: "cls-5",
    d: "M892.4,154.9c.39,1.41.76,2.82,1.12,4.24-.36-1.42-.73-2.83-1.12-4.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    className: "cls-5",
    d: "M875.06,111.2c.77,1.45,1.53,2.92,2.27,4.39-.74-1.47-1.49-2.94-2.27-4.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    className: "cls-5",
    d: "M877.43,115.8c.74,1.48,1.46,2.96,2.17,4.46-.7-1.49-1.43-2.98-2.17-4.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    className: "cls-5",
    d: "M864.46,93.46c.85,1.28,1.69,2.56,2.51,3.86-.82-1.29-1.66-2.58-2.51-3.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    className: "cls-5",
    d: "M861.55,89.21c.86,1.22,1.7,2.44,2.52,3.68-.83-1.23-1.67-2.46-2.52-3.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    className: "cls-5",
    d: "M899.7,197.07c.1,1.31.18,2.62.26,3.93-.08-1.31-.16-2.62-.26-3.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    className: "cls-5",
    d: "M899.23,191.69c.13,1.29.25,2.58.35,3.88-.11-1.3-.22-2.59-.35-3.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    className: "cls-5",
    d: "M900.06,202.45c.07,1.34.13,2.69.18,4.03-.05-1.35-.11-2.69-.18-4.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    className: "cls-5",
    d: "M749.48,100.71c1.8.94,3.57,1.93,5.32,2.96-1.75-1.03-3.52-2.01-5.32-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    className: "cls-5",
    d: "M900.28,207.85c.04,1.39.07,2.79.08,4.19-.02-1.4-.04-2.8-.08-4.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    className: "cls-5",
    d: "M760.51,107.26c1.5,1,2.98,2.03,4.43,3.09-1.45-1.07-2.93-2.09-4.43-3.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    className: "cls-5",
    d: "M893.75,160.04c.34,1.38.67,2.77.99,4.16-.32-1.39-.65-2.78-.99-4.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    className: "cls-5",
    d: "M896.07,170.45c.26,1.33.51,2.66.75,4-.24-1.34-.49-2.67-.75-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    className: "cls-5",
    d: "M894.97,165.22c.3,1.35.59,2.71.86,4.07-.28-1.36-.56-2.72-.86-4.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    className: "cls-5",
    d: "M765.78,110.99c1.33,1,2.65,2.01,3.93,3.06-1.29-1.05-2.6-2.06-3.93-3.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    className: "cls-5",
    d: "M897.9,181.01c.19,1.29.37,2.58.54,3.88-.17-1.3-.35-2.59-.54-3.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    className: "cls-5",
    d: "M898.63,186.34c.16,1.29.31,2.57.44,3.87-.14-1.29-.29-2.58-.44-3.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    className: "cls-5",
    d: "M897.05,175.71c.23,1.31.44,2.61.64,3.93-.2-1.31-.41-2.62-.64-3.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    className: "cls-5",
    d: "M217.77,429.62v.08c1.86-.02,3.74-.03,5.57-.08h.43c64.54-1.63,117.69-20.96,162.49-59.07-44.8,38.12-103.95,57.44-168.49,59.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    className: "cls-5",
    d: "M845.37,69.01c.8.88,1.59,1.78,2.38,2.67-.79-.9-1.57-1.79-2.38-2.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    className: "cls-5",
    d: "M848.82,72.9c.82.95,1.62,1.91,2.42,2.87-.8-.96-1.6-1.92-2.42-2.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    className: "cls-5",
    d: "M841.81,65.19c.78.82,1.55,1.65,2.33,2.49-.77-.83-1.54-1.67-2.33-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    className: "cls-5",
    d: "M770.87,115.02c1.16.97,2.31,1.95,3.43,2.96-1.12-1.01-2.27-1.99-3.43-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    className: "cls-5",
    d: "M855.4,80.91c.84,1.08,1.67,2.16,2.48,3.25-.82-1.09-1.64-2.18-2.48-3.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    className: "cls-5",
    d: "M838.55,61.85c-.13-.13-.27-.26-.41-.4.78.77,1.54,1.56,2.3,2.34-.63-.65-1.26-1.3-1.89-1.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    className: "cls-5",
    d: "M852.16,76.87c.83,1.01,1.65,2.04,2.46,3.06-.81-1.03-1.63-2.05-2.46-3.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    className: "cls-5",
    d: "M858.53,85.02c.85,1.15,1.68,2.3,2.51,3.47-.82-1.16-1.66-2.32-2.51-3.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    className: "cls-5",
    d: "M810.83,180.67s.02.09.04.13c-.01-.04-.02-.09-.04-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    className: "cls-5",
    d: "M788.91,133.96c.5.66,1,1.3,1.49,1.97-.48-.67-.99-1.31-1.49-1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    className: "cls-5",
    d: "M784.82,128.87c.64.75,1.28,1.49,1.9,2.25-.62-.76-1.26-1.51-1.9-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    className: "cls-5",
    d: "M799.36,150.33c.21.39.43.78.63,1.17-.2-.39-.42-.78-.63-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    className: "cls-5",
    d: "M804.84,162.04c.1.24.2.48.3.72-.1-.24-.2-.48-.3-.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    className: "cls-5",
    d: "M809.13,174.33c.03.11.07.21.1.31-.03-.11-.07-.21-.1-.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    className: "cls-5",
    d: "M796.18,144.71c.29.47.58.94.86,1.42-.28-.48-.57-.94-.86-1.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    className: "cls-5",
    d: "M217.77,344.16c1.41-.02,2.82-.03,4.23-.07-2.35.07-4.71.12-7.03.12.92,0,1.86-.03,2.8-.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    className: "cls-5",
    d: "M792.7,139.25c.38.56.77,1.11,1.14,1.68-.37-.57-.76-1.12-1.14-1.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    className: "cls-5",
    d: "M802.25,156.12c.14.31.3.62.44.93-.14-.31-.3-.62-.44-.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    className: "cls-5",
    d: "M778.04,121.5c-.74-.74-1.52-1.43-2.29-2.15.98.92,1.96,1.85,2.91,2.8-.21-.21-.41-.44-.63-.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    className: "cls-5",
    d: "M807.13,168.11c.06.17.13.34.19.52-.06-.17-.13-.34-.19-.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    className: "cls-5",
    d: "M780.41,123.98c.81.84,1.61,1.69,2.39,2.56-.78-.87-1.59-1.71-2.39-2.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    className: "cls-5",
    d: "M217.77,429.7h0c-.97,0-1.92.04-2.9.04.98,0,1.93-.03,2.9-.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    className: "cls-5",
    d: "M814.85,214.55v.39-.07h0v-.25c0-11.39-1.34-22.74-4-33.82,2.56,10.69,3.89,21.64,3.96,32.64,0,.38.01.75.02,1.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    className: "cls-5",
    d: "M840.45,63.79c.46.47.92.93,1.37,1.4-.45-.47-.91-.94-1.37-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    className: "cls-5",
    d: "M861.04,88.49c.17.24.35.48.51.72-.17-.24-.34-.48-.51-.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    className: "cls-5",
    d: "M857.88,84.16c.22.29.44.57.65.86-.21-.29-.43-.57-.65-.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    className: "cls-5",
    d: "M844.14,67.68c.41.44.82.88,1.23,1.33-.41-.44-.82-.88-1.23-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    className: "cls-5",
    d: "M864.07,92.89c.13.19.26.38.39.58-.13-.19-.26-.38-.39-.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    className: "cls-5",
    d: "M854.62,79.93c.26.33.52.65.78.98-.26-.33-.52-.65-.78-.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    className: "cls-5",
    d: "M847.75,71.68c.36.41.72.81,1.07,1.22-.35-.41-.71-.81-1.07-1.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    className: "cls-5",
    d: "M851.24,75.77c.31.37.62.73.92,1.1-.3-.37-.61-.73-.92-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    className: "cls-5",
    d: "M866.97,97.32l.3.47-.3-.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    className: "cls-5",
    d: "M900.38,213.01v-.2c0-.26-.01-.51-.02-.77.01.94.03,1.88.03,2.82v-.52c0-.45,0-.89-.02-1.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    className: "cls-5",
    d: "M881.75,124.97c.04.08.07.16.11.24l-.11-.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    className: "cls-5",
    d: "M896.82,174.45c.08.42.15.84.23,1.27-.07-.42-.15-.84-.23-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    className: "cls-5",
    d: "M790.4,135.93c.79,1.09,1.55,2.2,2.3,3.32-.76-1.11-1.51-2.23-2.3-3.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    className: "cls-5",
    d: "M897.69,179.64c.07.46.14.92.21,1.38-.07-.46-.14-.92-.21-1.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    className: "cls-5",
    d: "M898.44,184.89c.06.48.13.96.19,1.45-.06-.48-.12-.96-.19-1.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    className: "cls-5",
    d: "M895.84,169.3c.08.39.16.77.24,1.15-.08-.39-.16-.77-.24-1.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    className: "cls-5",
    d: "M793.84,140.93c.81,1.24,1.58,2.51,2.34,3.78-.76-1.27-1.53-2.54-2.34-3.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    className: "cls-5",
    d: "M797.04,146.12c.8,1.38,1.57,2.79,2.32,4.2-.75-1.42-1.52-2.82-2.32-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    className: "cls-5",
    d: "M800,151.5c.78,1.52,1.53,3.06,2.26,4.62-.73-1.55-1.47-3.1-2.26-4.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    className: "cls-5",
    d: "M892.19,154.14c.07.25.14.51.22.76-.07-.26-.14-.51-.22-.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    className: "cls-5",
    d: "M894.74,164.2c.08.34.16.68.23,1.02-.08-.34-.16-.68-.23-1.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    className: "cls-5",
    d: "M893.52,159.14c.08.3.15.6.23.9-.07-.3-.15-.6-.23-.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    className: "cls-5",
    d: "M759.96,106.89c.18.12.36.25.54.37-.18-.12-.36-.25-.54-.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    className: "cls-5",
    d: "M754.8,103.67c.09.05.18.11.27.16-.09-.05-.18-.11-.27-.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    className: "cls-5",
    d: "M782.8,126.53c.69.77,1.35,1.55,2.01,2.34-.67-.78-1.33-1.57-2.01-2.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    className: "cls-5",
    d: "M749.46,100.7h.02s-.02,0-.02,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    className: "cls-5",
    d: "M899.07,190.21c.05.49.11.99.16,1.48-.05-.49-.11-.99-.16-1.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    className: "cls-5",
    d: "M779.07,122.54c-.13-.13-.27-.25-.4-.39.59.6,1.17,1.22,1.75,1.83-.46-.48-.89-.97-1.35-1.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    className: "cls-5",
    d: "M890.74,149.18l.2.64c-.06-.21-.13-.42-.2-.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    className: "cls-5",
    d: "M786.72,131.13c.75.93,1.47,1.88,2.19,2.83-.72-.95-1.44-1.9-2.19-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    className: "cls-5",
    d: "M899.58,195.57c.04.5.08,1,.12,1.5-.04-.5-.08-1-.12-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    className: "cls-5",
    d: "M900.23,206.48c.02.46.03.91.05,1.37-.01-.46-.03-.91-.05-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    className: "cls-5",
    d: "M899.97,201c.03.49.06.97.08,1.46-.02-.49-.06-.97-.08-1.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    className: "cls-5",
    d: "M807.32,168.63c.65,1.88,1.25,3.78,1.81,5.7-.56-1.92-1.17-3.82-1.81-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    className: "cls-5",
    d: "M872.4,106.36l.17.29-.17-.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    className: "cls-5",
    d: "M769.72,114.04c.39.32.76.65,1.15.97-.39-.32-.76-.65-1.15-.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    className: "cls-5",
    d: "M805.14,162.76c.7,1.76,1.37,3.55,1.99,5.35-.63-1.8-1.29-3.58-1.99-5.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    className: "cls-5",
    d: "M869.75,101.82c.07.12.15.25.23.37-.07-.12-.15-.25-.23-.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    className: "cls-5",
    d: "M885.7,134.53c.05.12.09.23.13.35-.04-.11-.09-.23-.13-.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    className: "cls-5",
    d: "M883.79,129.73c.04.09.08.18.12.28-.04-.09-.08-.18-.12-.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    className: "cls-5",
    d: "M774.29,117.98c.49.45.97.91,1.46,1.37-.49-.46-.97-.92-1.46-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    className: "cls-5",
    d: "M879.6,120.26c.03.07.07.14.1.21-.03-.07-.07-.14-.1-.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    className: "cls-5",
    d: "M809.23,174.64c.58,1.99,1.11,3.99,1.61,6.02-.49-2.03-1.03-4.04-1.61-6.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    className: "cls-5",
    d: "M764.93,110.35c.29.21.56.43.85.64-.28-.21-.56-.43-.85-.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    className: "cls-5",
    d: "M877.32,115.58c.04.07.07.15.11.22-.04-.07-.07-.15-.11-.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    className: "cls-5",
    d: "M887.5,139.37c.05.14.11.29.16.43-.05-.14-.11-.29-.16-.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    className: "cls-5",
    d: "M802.69,157.05c.75,1.64,1.46,3.31,2.14,5-.68-1.68-1.39-3.35-2.14-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    className: "cls-5",
    d: "M889.18,144.25c.06.17.12.35.18.53-.06-.18-.12-.35-.18-.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    className: "cls-5",
    d: "M874.92,110.95l.14.25-.14-.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    className: "cls-5",
    d: "M814.86,214.87v-.25c0,.08,0,.17,0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    className: "cls-4",
    d: "M810.87,248.94s-.02.1-.04.14c.01-.05.02-.09.04-.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    className: "cls-4",
    d: "M722.82,426.71c-1.63.27-3.27.52-4.91.76,1.64-.23,3.28-.49,4.91-.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    className: "cls-4",
    d: "M825.24,380.07c-.91.76-1.82,1.53-2.74,2.27.92-.75,1.83-1.51,2.74-2.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    className: "cls-4",
    d: "M856.27,347.69c-.31.4-.61.81-.92,1.21.31-.4.61-.81.92-1.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    className: "cls-4",
    d: "M717.11,427.57c-1.5.21-3,.41-4.5.59,1.51-.18,3.01-.38,4.5-.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    className: "cls-4",
    d: "M705.62,428.86c-1.25.11-2.49.22-3.75.31,1.25-.09,2.5-.2,3.75-.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    className: "cls-4",
    d: "M896.86,255.13c-.05.29-.11.58-.16.86.05-.29.11-.58.16-.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    className: "cls-4",
    d: "M821.27,383.33c-.95.76-1.91,1.52-2.87,2.26.96-.74,1.92-1.5,2.87-2.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    className: "cls-4",
    d: "M881.95,304.34c-.18.42-.37.83-.56,1.24.18-.42.38-.83.56-1.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    className: "cls-4",
    d: "M711.39,428.29c-1.38.15-2.75.31-4.13.44,1.38-.13,2.76-.28,4.13-.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    className: "cls-4",
    d: "M782.89,407.62c-17.28,8.43-35.6,14.52-54.49,18.1,18.89-3.58,37.21-9.66,54.49-18.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    className: "cls-4",
    d: "M813.16,389.48c-1.06.77-2.13,1.53-3.2,2.27,1.08-.75,2.14-1.51,3.2-2.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    className: "cls-4",
    d: "M800.55,397.89c-1.26.78-2.53,1.54-3.8,2.29,1.27-.75,2.54-1.51,3.8-2.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    className: "cls-4",
    d: "M898.2,246.75l.02-.21c-.04.31-.08.62-.13.93.03-.24.08-.48.11-.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    className: "cls-4",
    d: "M804.81,395.2c-1.19.77-2.39,1.54-3.59,2.29,1.21-.75,2.4-1.52,3.59-2.29"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1110",
    className: "cls-4",
    x: 900.27,
    y: 214.99,
    width: 0.24,
    height: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    className: "cls-4",
    d: "M866.18,333.63c-.4.63-.81,1.26-1.22,1.88.41-.62.82-1.25,1.22-1.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    className: "cls-4",
    d: "M796.23,400.48c-1.33.78-2.67,1.54-4.01,2.28,1.35-.74,2.68-1.51,4.01-2.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    className: "cls-4",
    d: "M874.63,319.32c-.35.65-.7,1.28-1.05,1.92.35-.64.71-1.28,1.05-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    className: "cls-4",
    d: "M809,392.41c-1.12.77-2.25,1.53-3.38,2.27,1.14-.74,2.26-1.51,3.38-2.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    className: "cls-4",
    d: "M878.7,311.33c-.31.64-.62,1.28-.93,1.92.32-.64.62-1.28.93-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    className: "cls-4",
    d: "M728.28,425.75c-1.7.32-3.4.63-5.11.91,1.71-.29,3.41-.59,5.11-.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    className: "cls-4",
    d: "M817.24,386.46c-1,.76-2.01,1.52-3.03,2.27,1.02-.74,2.02-1.5,3.03-2.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    className: "cls-4",
    d: "M791.86,402.96c-1.4.77-2.81,1.53-4.23,2.27,1.42-.74,2.83-1.5,4.23-2.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    className: "cls-4",
    d: "M787.42,405.34c-1.47.77-2.95,1.52-4.45,2.25,1.49-.73,2.97-1.48,4.45-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    className: "cls-4",
    d: "M861.09,341.17c-.39.55-.79,1.09-1.18,1.63.39-.54.79-1.08,1.18-1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    className: "cls-4",
    d: "M850.88,354.41c-.44.52-.88,1.04-1.32,1.56.44-.52.88-1.04,1.32-1.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    className: "cls-4",
    d: "M793.84,288.81c-.37.57-.76,1.12-1.14,1.68.38-.56.77-1.11,1.14-1.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    className: "cls-4",
    d: "M797.04,283.62c-.28.48-.57.94-.86,1.41.28-.47.58-.93.86-1.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    className: "cls-4",
    d: "M870.56,326.54c-.3.52-.61,1.04-.92,1.55.31-.51.61-1.03.92-1.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    className: "cls-4",
    d: "M782.8,303.2c-.78.87-1.58,1.71-2.39,2.55.8-.84,1.61-1.68,2.39-2.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    className: "cls-4",
    d: "M786.71,298.61c-.62.76-1.26,1.51-1.9,2.25.64-.75,1.28-1.49,1.9-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    className: "cls-4",
    d: "M790.39,293.81c-.48.66-.99,1.31-1.48,1.96.5-.65,1-1.3,1.48-1.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    className: "cls-4",
    d: "M809.23,255.09c-.03.11-.07.23-.1.34.03-.11.07-.23.1-.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    className: "cls-4",
    d: "M895.25,263.27c-.07.32-.13.65-.2.96.07-.32.14-.64.2-.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    className: "cls-4",
    d: "M833.02,373.2c-.84.78-1.68,1.56-2.54,2.33.85-.77,1.69-1.55,2.54-2.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    className: "cls-4",
    d: "M807.32,261.11c-.06.17-.12.34-.19.52.06-.17.13-.34.19-.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    className: "cls-4",
    d: "M802.69,272.7c-.14.31-.3.62-.45.93.15-.31.3-.62.45-.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    className: "cls-4",
    d: "M805.14,266.98c-.1.24-.2.47-.3.71.1-.24.2-.47.3-.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    className: "cls-4",
    d: "M699.46,429.31c-1,.06-1.99.13-2.99.17,1-.04,2-.11,2.99-.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    className: "cls-4",
    d: "M799.99,278.25c-.2.39-.42.77-.63,1.16.21-.39.42-.77.63-1.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    className: "cls-4",
    d: "M888.38,287.84c-.18.51-.35,1.03-.53,1.54.18-.51.35-1.02.53-1.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    className: "cls-4",
    d: "M890.79,280.44c-.09.3-.19.59-.28.89.09-.3.19-.59.28-.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    className: "cls-4",
    d: "M838.55,367.89c.24-.24.46-.49.7-.73-.38.38-.75.77-1.14,1.16.14-.14.29-.28.43-.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    className: "cls-4",
    d: "M836.82,369.58c-.82.8-1.64,1.6-2.47,2.39.83-.79,1.65-1.59,2.47-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    className: "cls-4",
    d: "M844.83,361.31c-.35.38-.7.75-1.05,1.13.35-.38.71-.75,1.05-1.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    className: "cls-4",
    d: "M829.16,376.69c-.87.77-1.74,1.54-2.63,2.3.88-.76,1.76-1.53,2.63-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    className: "cls-4",
    d: "M778.03,308.24c.21-.21.41-.44.63-.66-.96.97-1.95,1.9-2.94,2.83.77-.73,1.56-1.43,2.31-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    className: "cls-4",
    d: "M774.3,311.74c-1.15,1.04-2.33,2.05-3.52,3.04,1.19-1,2.37-2,3.52-3.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    className: "cls-4",
    d: "M893.26,271.65c-.13.5-.27,1.01-.4,1.51.13-.5.27-1.01.4-1.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    className: "cls-4",
    d: "M692.84,429.61c-.61.02-1.21.05-1.83.06.61-.01,1.22-.04,1.83-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    className: "cls-4",
    d: "M764.98,319.36c-1.52,1.11-3.06,2.19-4.64,3.24,1.57-1.05,3.12-2.13,4.64-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    className: "cls-4",
    d: "M769.74,315.67c-1.34,1.09-2.7,2.15-4.09,3.18,1.39-1.03,2.75-2.09,4.09-3.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    className: "cls-4",
    d: "M885.36,296.08c-.24.61-.49,1.23-.73,1.84.24-.61.49-1.22.73-1.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    className: "cls-4",
    d: "M900.35,214.87c0,.24.01.48.02.72l.03-.47v-.25h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    className: "cls-4",
    d: "M596.13,322.66c-1.32-.76-2.61-1.55-3.91-2.34,1.3.79,2.59,1.59,3.91,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    className: "cls-4",
    d: "M545.19,278.75c-1.1-1.3-2.2-2.63-3.29-3.97,1.09,1.34,2.18,2.67,3.29,3.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    className: "cls-4",
    d: "M536.09,267.48c-1.12-1.45-2.23-2.93-3.34-4.41,1.11,1.48,2.22,2.96,3.34,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    className: "cls-4",
    d: "M554.55,289.23c-1.11-1.18-2.21-2.4-3.32-3.61,1.1,1.21,2.2,2.43,3.32,3.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    className: "cls-4",
    d: "M540.61,273.21c-1.11-1.37-2.21-2.78-3.3-4.18,1.1,1.4,2.2,2.81,3.3,4.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    className: "cls-4",
    d: "M549.83,284.09c-1.11-1.24-2.21-2.52-3.3-3.8,1.1,1.28,2.2,2.55,3.3,3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    className: "cls-4",
    d: "M569.25,303.4c-1.18-1.03-2.34-2.1-3.51-3.16,1.16,1.07,2.32,2.13,3.51,3.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    className: "cls-4",
    d: "M559.35,294.16c-1.12-1.12-2.23-2.27-3.33-3.42,1.11,1.15,2.21,2.3,3.33,3.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    className: "cls-4",
    d: "M564.25,298.89c-1.15-1.07-2.28-2.19-3.42-3.3,1.13,1.11,2.27,2.22,3.42,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    className: "cls-4",
    d: "M574.36,307.7c-1.2-.98-2.38-1.99-3.57-3,1.18,1.01,2.36,2.02,3.57,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    className: "cls-4",
    d: "M531.61,261.57c-1.11-1.49-2.21-3.02-3.31-4.54,1.1,1.52,2.2,3.05,3.31,4.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    className: "cls-4",
    d: "M509.58,229.3c-1.31-2.06-2.63-4.14-3.95-6.24,1.32,2.1,2.63,4.18,3.95,6.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    className: "cls-4",
    d: "M513.96,236.08c-1.25-1.91-2.5-3.84-3.74-5.79,1.25,1.95,2.5,3.89,3.74,5.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    className: "cls-4",
    d: "M522.75,249.18c-1.14-1.64-2.27-3.32-3.4-5,1.13,1.68,2.27,3.35,3.4,5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    className: "cls-4",
    d: "M518.35,242.72c-1.16-1.73-2.32-3.49-3.48-5.26,1.16,1.76,2.32,3.53,3.48,5.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    className: "cls-4",
    d: "M527.16,255.46c-1.12-1.57-2.24-3.17-3.36-4.78,1.12,1.6,2.24,3.21,3.36,4.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    className: "cls-4",
    d: "M627.05,336.07c-1.47-.46-2.9-.96-4.35-1.45,1.44.49,2.88.99,4.35,1.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    className: "cls-4",
    d: "M640.83,339.69c-1.52-.33-3.01-.71-4.5-1.08,1.49.37,2.98.75,4.5,1.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    className: "cls-4",
    d: "M655.51,342.27c-1.57-.21-3.09-.47-4.62-.71,1.53.24,3.05.5,4.62.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    className: "cls-4",
    d: "M648.05,341.12c-1.57-.28-3.11-.6-4.65-.91,1.54.31,3.07.64,4.65.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    className: "cls-4",
    d: "M663.23,343.17c-1.42-.14-2.8-.32-4.2-.49,1.4.16,2.77.35,4.2.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    className: "cls-4",
    d: "M579.59,311.78c-1.23-.92-2.44-1.88-3.65-2.84,1.21.96,2.42,1.92,3.65,2.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    className: "cls-4",
    d: "M671.2,343.78c-1.22-.07-2.4-.19-3.6-.28,1.2.09,2.38.21,3.6.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    className: "cls-4",
    d: "M633.83,338.01c-1.51-.4-2.99-.84-4.47-1.28,1.48.44,2.96.88,4.47,1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    className: "cls-4",
    d: "M607.95,328.76c-1.39-.64-2.74-1.32-4.1-2,1.36.68,2.71,1.36,4.1,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    className: "cls-4",
    d: "M601.95,325.83c-1.34-.69-2.66-1.43-3.98-2.16,1.32.73,2.63,1.46,3.98,2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    className: "cls-4",
    d: "M590.47,319.27c-1.29-.81-2.55-1.66-3.81-2.51,1.26.85,2.52,1.7,3.81,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    className: "cls-4",
    d: "M584.96,315.64c-1.26-.87-2.49-1.78-3.73-2.68,1.24.9,2.47,1.81,3.73,2.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    className: "cls-4",
    d: "M620.49,333.88c-1.45-.52-2.87-1.09-4.29-1.64,1.42.56,2.84,1.12,4.29,1.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    className: "cls-4",
    d: "M614.12,331.44c-1.42-.58-2.81-1.21-4.2-1.82,1.39.62,2.78,1.24,4.2,1.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    className: "cls-4",
    d: "M900.39,216.69c0-.09,0-.18,0-.28v.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    className: "cls-4",
    d: "M900.29,216.69h.09v-.28c0-.27-.01-.55-.02-.82l-.07,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M900.34,214.87h0c-.97-22.89-19.81-40.95-42.72-40.95-22.91,0-41.75,18.06-42.72,40.95h0s0,0,0,0h-.05v.31c0,11.37-1.34,22.7-3.99,33.75-.01.05-.02.1-.04.15-.49,2.02-1.03,4.03-1.6,6.01-.04.11-.07.22-.11.34-.56,1.91-1.17,3.81-1.81,5.68-.06.17-.12.34-.18.52-.63,1.8-1.29,3.59-1.99,5.36-.1.24-.2.48-.3.71-.68,1.68-1.39,3.36-2.14,5-.14.31-.3.62-.45.93-.73,1.55-1.47,3.1-2.26,4.62-.2.39-.42.77-.63,1.16-.75,1.42-1.52,2.83-2.33,4.21-.28.48-.57.94-.86,1.41-.77,1.27-1.54,2.54-2.35,3.78-.37.57-.76,1.12-1.14,1.68-.76,1.12-1.51,2.23-2.31,3.32-.48.66-.99,1.31-1.48,1.96-.72.96-1.45,1.91-2.2,2.84-.62.76-1.26,1.5-1.9,2.25-.67.78-1.33,1.57-2.02,2.34-.78.87-1.58,1.71-2.39,2.55-.45.48-.89.98-1.35,1.45-.13.13-.27.25-.4.39-.21.21-.41.44-.63.66-.75.74-1.54,1.45-2.32,2.17-.47.44-.94.9-1.42,1.33-1.15,1.04-2.33,2.05-3.52,3.04-.35.29-.69.59-1.04.88-1.34,1.09-2.71,2.15-4.09,3.18-.23.17-.45.34-.67.51-1.52,1.12-3.06,2.2-4.64,3.24-.11.07-.21.15-.32.22-1.29.85-2.59,1.67-3.91,2.47-19.76,11.97-43.31,18.54-68.57,18.86-.63.01-1.13.02-1.62.04h0s-.48.01-.48.01c-.92,0-1.86-.03-2.8-.05h0s-.15,0-.15,0h0c-.99,0-2,0-2.98-.03h-.03c-2.79-.07-5.54-.18-8.24-.34-1.22-.07-2.4-.19-3.6-.28-1.46-.11-2.94-.2-4.38-.34-1.44-.14-2.8-.32-4.2-.48-1.17-.14-2.36-.25-3.51-.4-1.57-.21-3.09-.47-4.62-.72-.94-.15-1.91-.28-2.84-.44-1.57-.28-3.1-.6-4.65-.91-.86-.17-1.73-.32-2.58-.51-1.53-.33-3.01-.71-4.5-1.08-.83-.2-1.68-.39-2.5-.6-1.51-.4-2.99-.84-4.47-1.28-.77-.22-1.55-.43-2.3-.66-1.47-.46-2.91-.96-4.35-1.45-.74-.25-1.49-.48-2.22-.74-1.45-.52-2.87-1.09-4.29-1.64-.69-.27-1.39-.52-2.07-.8-1.42-.58-2.81-1.21-4.2-1.83-.66-.29-1.33-.56-1.98-.86-1.38-.64-2.74-1.32-4.09-2-.63-.31-1.28-.61-1.9-.93-1.34-.69-2.66-1.43-3.97-2.16-.61-.34-1.24-.66-1.85-1.01-1.32-.76-2.61-1.55-3.91-2.34-.58-.36-1.18-.69-1.75-1.05-1.29-.81-2.55-1.66-3.81-2.51-.56-.38-1.14-.73-1.7-1.12-1.26-.87-2.49-1.78-3.73-2.68-.54-.4-1.1-.77-1.63-1.17-1.23-.92-2.44-1.88-3.64-2.84-.53-.42-1.07-.82-1.59-1.24-1.2-.97-2.38-1.99-3.57-3-.51-.44-1.04-.85-1.54-1.3-1.18-1.03-2.34-2.1-3.51-3.16-.5-.45-1-.89-1.49-1.35-1.15-1.07-2.28-2.19-3.42-3.3-.49-.48-.99-.94-1.48-1.43-1.12-1.12-2.23-2.27-3.33-3.42-.49-.51-.98-1-1.47-1.51-1.11-1.18-2.22-2.4-3.32-3.61-.47-.51-.93-1.01-1.4-1.53-1.11-1.24-2.21-2.52-3.3-3.8-.45-.52-.9-1.02-1.34-1.54-1.1-1.3-2.19-2.64-3.29-3.97-.43-.52-.86-1.03-1.29-1.57-1.11-1.37-2.21-2.78-3.31-4.18-.4-.52-.81-1.02-1.22-1.54-1.12-1.45-2.23-2.93-3.34-4.41-.38-.51-.76-1-1.14-1.51-1.11-1.49-2.21-3.02-3.31-4.54-.38-.53-.76-1.04-1.14-1.57-1.12-1.57-2.24-3.17-3.36-4.78-.35-.5-.7-1-1.05-1.5-1.14-1.64-2.27-3.32-3.4-5-.33-.49-.67-.97-1-1.47-1.16-1.73-2.32-3.49-3.48-5.26-.3-.46-.61-.91-.91-1.38-1.25-1.91-2.5-3.84-3.74-5.79-.21-.33-.43-.66-.64-.99-1.31-2.06-2.63-4.14-3.95-6.24-.15-.24-.3-.48-.46-.72-1.39-2.22-2.79-4.46-4.19-6.73-.07-.12-.15-.23-.22-.35-.1-.15-.19-.31-.29-.46l-50.47,81.92,13.85-22.37-13.84,22.38c18.26,26.82,38.91,52.64,64.3,74.13,45.13,38.19,98.66,57.43,163.64,58.81h.4s.05,0,.08,0c-.03,0-.05,0-.08,0,1.36.03,2.74.03,4.11.04h0c1.01,0,2.01.03,3.04.03-.97,0-1.92-.03-2.88-.04h0c.96,0,1.9.04,2.87.04h.02c1.83,0,3.66-.02,5.48-.06.61-.02,1.22-.04,1.83-.06,1.21-.04,2.42-.07,3.62-.13,1-.05,2-.12,2.99-.18.81-.05,1.62-.08,2.42-.14,1.25-.09,2.5-.2,3.75-.31.54-.05,1.09-.08,1.63-.13,1.38-.13,2.76-.28,4.13-.44.4-.05.81-.08,1.22-.13,1.51-.18,3.01-.38,4.5-.59.27-.04.54-.07.8-.1,1.64-.23,3.28-.48,4.91-.75.12-.02.23-.04.35-.05,1.71-.29,3.41-.59,5.11-.91l.12-.02c18.89-3.58,37.21-9.67,54.49-18.1.03-.01.05-.02.08-.04,1.49-.73,2.97-1.48,4.45-2.25.07-.04.14-.07.21-.1,1.42-.74,2.83-1.5,4.23-2.27l.36-.19c1.35-.74,2.68-1.51,4.01-2.28.17-.1.35-.2.52-.3,1.27-.75,2.54-1.52,3.8-2.29.22-.14.45-.27.67-.4,1.21-.75,2.4-1.52,3.59-2.29.27-.17.54-.34.81-.52,1.14-.74,2.26-1.51,3.38-2.28.31-.22.64-.42.95-.64,1.08-.74,2.14-1.51,3.21-2.28.35-.25.7-.5,1.05-.75,1.02-.74,2.03-1.5,3.03-2.27.39-.29.78-.58,1.16-.87.97-.74,1.92-1.5,2.87-2.26.41-.33.83-.65,1.24-.98.92-.75,1.83-1.51,2.74-2.27.43-.36.86-.72,1.29-1.08.88-.76,1.76-1.52,2.63-2.3.44-.39.88-.77,1.32-1.16.85-.77,1.69-1.55,2.54-2.33.44-.41.89-.81,1.33-1.23.83-.79,1.65-1.59,2.47-2.39.43-.42.87-.84,1.3-1.27.39-.38.76-.77,1.14-1.16,1.53-1.55,3.04-3.12,4.52-4.71.35-.38.71-.75,1.05-1.13,1.61-1.76,3.18-3.54,4.72-5.35.44-.52.88-1.04,1.32-1.56,1.52-1.81,3.02-3.65,4.47-5.51.31-.4.61-.81.92-1.21,1.24-1.61,2.46-3.25,3.65-4.89.39-.54.79-1.08,1.18-1.63,1.32-1.86,2.61-3.75,3.87-5.65.41-.62.82-1.25,1.22-1.88,1.18-1.83,2.34-3.68,3.47-5.55.31-.51.61-1.03.91-1.55,1.03-1.75,2.04-3.52,3.02-5.3.35-.64.71-1.28,1.05-1.92,1.08-2,2.12-4.03,3.14-6.07.32-.64.62-1.28.93-1.92.92-1.9,1.82-3.82,2.69-5.76.18-.42.38-.83.56-1.24.93-2.12,1.82-4.26,2.68-6.42.24-.61.49-1.22.73-1.84.87-2.22,1.7-4.45,2.49-6.7.18-.51.35-1.03.53-1.54.74-2.16,1.45-4.33,2.13-6.52.09-.3.19-.59.28-.89.73-2.41,1.41-4.84,2.07-7.28.13-.5.27-1.01.4-1.51.64-2.46,1.23-4.93,1.79-7.41.07-.32.14-.64.21-.96.52-2.41,1.01-4.83,1.45-7.27.05-.29.11-.58.16-.86.45-2.54.86-5.1,1.22-7.67.04-.31.09-.62.13-.93l2.07-29.84h.01l.08-1.1c0-.24,0-.48-.02-.72ZM500.74,215.24h.02s0,0,0,0h-.02ZM685.53,344.21c-.98,0-1.93-.03-2.9-.04.97.02,1.92.04,2.9.04,0,0,0,0,0,0ZM696.64,343.79c20.07-1.48,38.86-6.98,55.27-16.06-16.41,9.09-35.2,14.58-55.27,16.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M900.38,212.05c-.02-1.4-.04-2.8-.09-4.19h-.02c-.02-.46-.03-.92-.05-1.37-.05-1.35-.1-2.69-.18-4.03-.03-.48-.06-.97-.09-1.45-.08-1.31-.17-2.62-.26-3.93-.04-.5-.08-1-.12-1.5-.11-1.3-.22-2.59-.35-3.88-.05-.5-.1-.99-.16-1.48-.14-1.29-.28-2.58-.44-3.87-.06-.48-.12-.97-.19-1.45-.17-1.29-.35-2.59-.54-3.88-.07-.46-.14-.92-.21-1.38-.2-1.31-.42-2.62-.64-3.93-.07-.42-.15-.84-.23-1.27-.24-1.34-.49-2.67-.75-4-.08-.39-.16-.77-.24-1.15-.28-1.36-.56-2.72-.86-4.07-.08-.34-.16-.68-.24-1.02-.32-1.39-.65-2.78-.99-4.16-.07-.3-.15-.6-.23-.9-.36-1.42-.73-2.83-1.11-4.24-.07-.26-.14-.51-.21-.76-.4-1.45-.82-2.89-1.25-4.33l-.2-.64c-.45-1.47-.91-2.94-1.39-4.4-.06-.17-.12-.35-.18-.52-.49-1.49-1-2.98-1.53-4.45-.05-.14-.1-.29-.16-.43-.54-1.51-1.09-3-1.66-4.49-.04-.12-.09-.23-.13-.35-.58-1.51-1.18-3.02-1.8-4.52-.04-.09-.08-.18-.12-.28-.63-1.51-1.27-3.02-1.93-4.52l-.11-.24c-.67-1.51-1.35-3.01-2.05-4.5-.03-.07-.07-.14-.1-.21-.71-1.5-1.43-2.98-2.17-4.46-.04-.07-.07-.15-.11-.22-.74-1.47-1.49-2.93-2.27-4.39l-.14-.25c-.77-1.44-1.55-2.87-2.35-4.29-.06-.1-.11-.2-.17-.29-.79-1.4-1.6-2.79-2.43-4.17-.07-.12-.15-.24-.22-.37-.81-1.35-1.64-2.69-2.48-4.03l-.3-.47c-.82-1.29-1.66-2.58-2.51-3.86-.13-.19-.26-.39-.39-.58-.83-1.23-1.67-2.46-2.52-3.68-.17-.24-.34-.48-.51-.72-.82-1.16-1.66-2.32-2.51-3.46-.21-.29-.43-.57-.65-.86-.82-1.09-1.64-2.18-2.48-3.25-.26-.33-.52-.65-.78-.98-.81-1.03-1.63-2.05-2.46-3.07-.3-.37-.61-.73-.92-1.1-.8-.96-1.6-1.92-2.42-2.87-.35-.41-.71-.81-1.07-1.22-.79-.9-1.57-1.79-2.38-2.67-.41-.45-.82-.88-1.23-1.33-.77-.83-1.54-1.67-2.32-2.49-.45-.47-.91-.94-1.37-1.4-.77-.78-1.53-1.57-2.3-2.34-.48-.48-.97-.94-1.45-1.42-.77-.75-1.54-1.5-2.32-2.24-.5-.47-1-.92-1.5-1.39-.78-.73-1.57-1.46-2.36-2.17-.5-.45-1.01-.89-1.51-1.33-.81-.71-1.61-1.43-2.43-2.13-.49-.42-.99-.83-1.48-1.24-.85-.71-1.69-1.42-2.55-2.12-.47-.38-.94-.75-1.42-1.12-.89-.71-1.79-1.43-2.7-2.12-.44-.34-.89-.67-1.33-1.01-.95-.72-1.89-1.43-2.85-2.14-.41-.29-.82-.58-1.23-.88-1.01-.72-2.01-1.45-3.03-2.15-.36-.25-.73-.49-1.09-.74-1.08-.74-2.16-1.47-3.25-2.19-.31-.2-.62-.4-.93-.6-1.15-.75-2.3-1.49-3.47-2.21-.26-.16-.52-.32-.78-.47-1.22-.75-2.45-1.5-3.69-2.22-.2-.12-.41-.24-.62-.36-1.3-.75-2.6-1.5-3.91-2.23-.15-.08-.3-.16-.45-.24-1.38-.76-2.76-1.5-4.15-2.23-.08-.04-.17-.08-.25-.13-1.46-.76-2.93-1.5-4.41-2.23-.03-.02-.06-.03-.1-.05-18.88-9.21-38.99-15.61-59.71-19.02-.04,0-.08-.01-.11-.02-1.71-.28-3.43-.55-5.15-.79-.16-.02-.33-.04-.49-.06-1.6-.22-3.2-.44-4.82-.62-.29-.04-.57-.06-.86-.09-1.49-.17-2.98-.34-4.48-.47-.47-.05-.94-.08-1.42-.12-1.32-.11-2.64-.23-3.96-.32-.72-.05-1.43-.08-2.15-.12-1.09-.07-2.17-.14-3.26-.19-1.09-.05-2.18-.08-3.27-.12-.72-.02-1.45-.06-2.17-.07-1.82-.04-3.65-.07-5.48-.07h-.02c-.98,0-1.92.03-2.89.04h0s0,0,0,0h0s-.08,0-.12,0c-1.82.02-3.65.03-5.44.07h-.44c-64.54,1.64-117.69,20.95-162.49,59.07-25.31,21.54-45.79,47.25-63.79,73.89l-3.54,5.74-46.9,76.13c-46.91,76.85-88.41,126.54-177.92,129.15-1.29.04-2.58.05-3.87.06h0s-.65,0-.65,0c-.84.02-1.69.04-2.52.04l-.48-.02c-.5-.02-.99-.03-1.62-.04-35.97-.46-68.48-13.58-91.53-36.95-23.02-23.34-35.73-56-35.8-92.01v-.32c-.02,23.58-19.28,42.68-42.86,42.66-21.42-.02-39.52-15.91-42.3-37.15l1.83,26.37c6.47,46.39,27.09,88.59,59.65,121.14,39.88,39.88,94.23,61.85,153.02,61.85.98,0,1.93-.03,2.9-.04h0s.19,0,.19,0v-.09c64.47-1.66,123.54-20.98,168.3-59.06,11.29-9.67,21.83-20.17,31.54-31.42l5.73-6.76c.05-.07.11-.13.16-.2-.05.06-.1.13-.15.19,9.5-11.48,18.25-23.47,26.49-35.66l50.46-81.92c46.91-76.85,88.41-126.53,177.91-129.14h0c1.26-.04,2.52-.06,3.78-.08h.46s0,0,0,0c.94-.01,1.86-.04,2.81-.04h0c-.06,0-.12,0-.19,0,.1,0,.19,0,.29,0,.38,0,.76.01,1.14.02-.38,0-.76-.02-1.14-.02-.03,0-.06,0-.09,0h.45c.55.03,1.11.05,1.64.05,14.47.19,28.39,2.42,41.35,6.55.03,0,.06.02.09.03,1.12.36,2.22.73,3.33,1.11.13.05.26.09.39.14,1.02.36,2.04.73,3.05,1.12.21.08.42.16.63.25.94.36,1.88.74,2.82,1.12.27.11.54.23.81.35.88.37,1.76.74,2.62,1.13.31.14.61.29.92.43.06.03.12.06.18.09,1.94.89,3.85,1.82,5.73,2.8h.03c1.8.96,3.57,1.95,5.32,2.97.09.05.18.11.27.16,1.66.98,3.29,2,4.9,3.06.18.12.36.25.54.37,1.5,1,2.98,2.03,4.43,3.09.29.21.56.43.85.64,1.33,1,2.65,2.01,3.93,3.06.39.32.76.65,1.15.97,1.16.97,2.31,1.95,3.43,2.96.49.45.97.92,1.46,1.37.76.71,1.54,1.41,2.29,2.15.21.21.41.44.63.65.13.13.27.25.4.39.46.47.9.96,1.35,1.44.8.85,1.61,1.69,2.39,2.56.69.77,1.35,1.55,2.01,2.34.64.75,1.28,1.49,1.9,2.26.75.93,1.47,1.88,2.19,2.84.5.66,1,1.3,1.49,1.97.79,1.09,1.55,2.2,2.3,3.32.38.56.77,1.11,1.14,1.68.81,1.24,1.58,2.51,2.34,3.78.28.47.58.94.86,1.41.8,1.38,1.57,2.79,2.32,4.21.21.39.43.78.63,1.17.79,1.52,1.53,3.06,2.26,4.62.15.31.3.62.44.93.75,1.64,1.46,3.31,2.15,5,.1.24.2.48.3.72.7,1.76,1.36,3.55,1.99,5.35.06.17.13.34.19.52.65,1.88,1.25,3.78,1.81,5.7.03.1.07.21.1.31.58,1.99,1.11,3.99,1.6,6.02.01.05.02.09.04.13,2.66,11.08,4,22.43,4,33.82v.25h.05c1-23.59,20.94-41.9,44.53-40.9,22.19.94,39.96,18.71,40.9,40.9h.05c0-.94-.02-1.88-.03-2.82ZM450.35,133.08l-.86,1.39.86-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,215.11v.14c0-.12,0-.25,0-.38v.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M386.07,58.9C341.34,21.05,288.36,1.82,224.16.13l-1.79-.04c-1.31-.03-2.65-.03-3.98-.04v-.02s-1.07-.02-1.07-.02v.03c-.81-.01-1.63-.03-2.46-.03C156.42,0,102.31,21.74,62.5,61.2,22.71,100.65.52,154.51.02,212.81v.2c0,.45-.02.89-.02,1.34v.51h0s0,0,0,0h0s0,0,0,0c0,.13,0,.25,0,.37v.06c.02,1.69.14,3.37.35,5.04v.04c3.05,23.39,24.5,39.88,47.92,36.84,21.31-2.76,37.26-20.89,37.25-42.35h0s0,0,0,0h0v-.31c.01-.37.02-.74.02-1.12.33-36.12,13.4-68.76,36.79-91.93,23.42-23.19,56.27-35.97,92.5-35.97.98,0,1.93.03,2.9.04h0s.16,0,.16,0c1.01.01,2.03.02,3.02.04,89.49,2.18,131.39,52.09,178.96,129.33l50.47-81.92c-18.26-26.82-38.91-52.64-64.31-74.13Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThreadsLogoDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/threads-logo-dark.ff477fe6b09ee2f78d20802ddcf2a24e.svg";